export const PUBLIC_MARKETING_PATH = "/"

/** Marketing page when the visitor already has a session (cookieless `/welcome` → `/`). */
export const SIGNED_IN_MARKETING_PATH = "/welcome"

export function isMarketingPath(path: string) {
  return path === PUBLIC_MARKETING_PATH || path === SIGNED_IN_MARKETING_PATH
}
